export default (props) => {
    const { MediaUploadCheck, MediaUpload } = wp.blockEditor;
    const { Button,__experimentalText,Card, CardBody, CardMedia } = wp.components;

    return <Card>
                <CardMedia>
                    { props.attributes[props.attributeName].id !== null ?<img src={props.attributes[props.attributeName].url} /> : <__experimentalText>{ wp.i18n('No picture selected.','cdm-blocks') }</__experimentalText>}
                </CardMedia>
                <CardBody>
                    <MediaUploadCheck>
                        <MediaUpload
                            onSelect={ ( media ) => {
                                props.setAttributes({
                                    [props.attributeName]:{
                                        id:media.id,
                                        name:media.title,
                                        url:media.url
                                    }
                                })
                            }}
                            allowedTypes={ props.ALLOWED_MEDIA_TYPES }
                            value={ props.attributes[props.attributeName].id }
                            render={ ( { open } ) => (
                                <Button isPrimary onClick={ open }>
                                    { wp.i18n('Open media library.','cdm-blocks') }
                                </Button>
                            ) }
                        />
                    </MediaUploadCheck>
                    <Button isPrimary onClick={ ()=>{
                        props.setAttributes({
                            [props.attributeName]:{
                                id:null,
                                name:"",
                                url:""
                            }
                        })
                    } }>{ wp.i18n('Remove image','cdm-blocks') }</Button>
                </CardBody>
            </Card>
}
